import * as React from "react";
import { useHistory, useLocation } from "react-router-dom";

import { Modal, Button } from "semantic-ui-react";

const AuthRequiredModal = ({
  showAuthRequired,
  setshowAuthRequired,
  redirectLogin,
}) => {
  const history = useHistory();
  const location = useLocation();
  let referrer = location?.state?.from ? location.state.from : null;

  // close modal if the URL changes
  React.useEffect(() => {
    return history.listen(() => {
      setshowAuthRequired(false);
    });
  }, [history, setshowAuthRequired]);

  const cancelClose = () => {
    setshowAuthRequired(false);
    if (referrer) {
      history.push(referrer);
    } else {
      history.push("/");
    }
  };

  return (
    <Modal
      basic
      dimmer={"blurring"}
      open={showAuthRequired}
      closeOnDocumentClick={false}
      closeOnDimmerClick={false}
      role="dialog"
      className="login-modal"
    >
      <Modal.Content>
        <p>You have to be logged in to access this page</p>

        <Button
          className="login-button"
          basic
          positive
          size="massive"
          onClick={redirectLogin}
        >
          LOG IN
        </Button>
        <span className="negative" onClick={cancelClose}>
          Cancel
        </span>
      </Modal.Content>
    </Modal>
  );
};
export default AuthRequiredModal;
